import { SongPeaksResponse } from 'services/api/responses/responseTypes';
import type { Nullable } from '../../types';
import { HTTPError } from '../error';
import { ISongPeaks } from './iSongPeaks';

export default class SongPeaks implements ISongPeaks {
  version: number;

  channels: number;

  sampleRate: number;

  samplesPerPixel: number;

  bits: number;

  length: number;

  data: number[];

  constructor(data: Nullable<SongPeaksResponse>) {
    if (data == null || !this.isResponseDataValid(data)) {
      throw HTTPError.responseError();
    }

    this.version = data.version;
    this.channels = data.channels;
    this.sampleRate = data.sample_rate;
    this.samplesPerPixel = data.samples_per_pixel;
    this.bits = data.bits;
    this.length = data.length;
    this.data = this.normalizeSongPeaksData(data.data);
  }

  private normalizeSongPeaksData(responseData: number[]): number[] {
    return responseData
      .slice(0, responseData.length / this.channels)
      .map((val) => (val >= 0x8000 ? -(0x10000 - val) / 0x8000 : val / 0x7fff));
  }

  // eslint-disable-next-line class-methods-use-this
  private isResponseDataValid(data: Nullable<SongPeaksResponse>): boolean {
    const has = Object.prototype.hasOwnProperty;
    return !(
      !has.call(data, 'version') ||
      !has.call(data, 'channels') ||
      !has.call(data, 'sample_rate') ||
      !has.call(data, 'samples_per_pixel') ||
      !has.call(data, 'bits') ||
      !has.call(data, 'length') ||
      !has.call(data, 'data')
    );
  }
}
